import React, { useContext } from 'react'
import { UserContext } from './Main';

export default function About() {

    const value=useContext(UserContext)

    console.log(value);

    return (
        <div className='about'>
            <div className="home-section About">
                <div className="devs-title"><p><span className='pink'>&#47;&#47;</span>About</p></div>
                <div className='thanks-to-content'>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Sit ipsam iusto minima,
                    nesciunt ab illum corrupti mollitia repellendus natus. Soluta nulla eum sed minus.
                    Similique facilis sequi impedit quos nihil.
                </div>
            </div>

            <div className="home-section rules">
                <div className="devs-title"><p><span className='pink'>&#47;&#47;</span>Rules And Regulations</p></div>
                <div className='thanks-to-content'>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Sit ipsam iusto minima,
                    nesciunt ab illum corrupti mollitia repellendus natus. Soluta nulla eum sed minus.
                    Similique facilis sequi impedit quos nihil.
                </div>
            </div>

            <div className="home-section thanks-to">
                <div className="devs-title"><p><span className='pink'>&#47;&#47;</span>Thanks_to</p></div>
                <div className='thanks-to-content'>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Sit ipsam iusto minima,
                    nesciunt ab illum corrupti mollitia repellendus natus. Soluta nulla eum sed minus.
                    Similique facilis sequi impedit quos nihil.
                </div>
            </div>
        </div>
    )
}